import React, { useState, useEffect } from "react";
import ParentMenu from "./ParentMenu";
import SubMenu from "./SubMenu";
import useAxios from "../../hooks/useAxios";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";
import { Sizes } from "../../styles";
import FocusTrap from "focus-trap-react";

const App = ( { lang, postid, menu } ) => {
	const menuItems = JSON.parse(menu);
	const formattedLanguage = lang.split("_")[0];
	// Fetch the inactive language for the language switcher button
	const { response: inactiveLanguage, } = useAxios(`lang-switcher?lang=${formattedLanguage}&post_id=${postid}`);
	const [activeMenuItems, setActiveMenuItems] = useState({});
	const [subMenuIsOpen, setSubMenuIsOpen] = useState(false);
	const [expanded, setExpanded] = useState(0);

	const isDesktopOrLaptop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.largeMenu})`,
	});

	// get the string to display on the language switcher button
	const getLanguage = () => {
		const languageKey = formattedLanguage === "en" ? "fr" : "en";
		if (inactiveLanguage.length) return inactiveLanguage[0][languageKey];
	}

	const addDarkOverlay = () => {
		if (subMenuIsOpen) {
			const overlay = document.createElement('div');
			overlay.classList.add('dark-overlay');
			document.body.appendChild(overlay);
		} else if (!subMenuIsOpen && document.querySelector('.dark-overlay')) {
			document.querySelector('.dark-overlay').remove();
		}
	}

	const handleOutsideClick = (event) => {
		if (!isDesktopOrLaptop) return;

		const target = event.target;
		const parentLinks = ".parent-links > li button";
		const upperMenuLinks = ".upper-menu a";
		const submenuLinks = ".submenu-links a";

		if (!target.closest(parentLinks) && !target.closest(upperMenuLinks) && !target.closest(submenuLinks)) {
			setSubMenuIsOpen(false);
			setActiveMenuItems({});
			setExpanded(0);
		}
	};

	const addBorderRadius = () => {
		const header = document.getElementById('header');
		header.classList.add('has-submenu-open');
	}

	const removeBorderRadius = () => {
		const header = document.getElementById('header');
		header.classList.remove('has-submenu-open');
	}

	const handleEscPress = (event) => {
		if (event.key === "Escape") {
			setSubMenuIsOpen(false);
			setActiveMenuItems({});
			setExpanded(0);
		}
	}

	useEffect(() => {
		addDarkOverlay();
		
		if (subMenuIsOpen) {
			document.addEventListener("click", handleOutsideClick);
			window.addEventListener("keydown", handleEscPress);
			addBorderRadius();
		} else {
			removeBorderRadius();
		}
		
		return () => {
			document.removeEventListener("click", handleOutsideClick);
			window.addEventListener("keydown", handleEscPress);
		}
	}, [subMenuIsOpen]);

	return (
		<>
			<FocusTrap
				focusTrapOptions={{
					initialFocus: false,
				}}
				active={subMenuIsOpen}
			>
				<div>
					<ParentMenu
						menuItems={menuItems}
						setActiveMenuItems={setActiveMenuItems}
						setSubMenuIsOpen={setSubMenuIsOpen}
						subMenuIsOpen={subMenuIsOpen}
						setExpanded={setExpanded}
						expanded={expanded}
						inactiveLanguage={getLanguage()}
					/>
					<SubMenu
						activeMenuItems={activeMenuItems}
						allMenuItems={menuItems}
						subMenuIsOpen={subMenuIsOpen}
						setSubMenuIsOpen={setSubMenuIsOpen}
						setExpanded={setExpanded}
						expanded={expanded}
						inactiveLanguage={getLanguage()}
					/>
				</div>
			</FocusTrap>
		</>
	);
};

App.propTypes = {
	lang: PropTypes.string.isRequired,
	postid: PropTypes.number.isRequired,
	menu: PropTypes.string.isRequired,
};

export default App;
